import React from 'react';
import { TextInput, NumberInputProps } from 'react-admin';
import InputAdornment from '@mui/material/InputAdornment';

const NumberInput = ({
  popups = null,
  ...props
} : NumberInputProps & { popups?: React.ReactNode }) => (
  <TextInput
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    sx={{ '& .MuiFilledInput-root': { padding: 0 } }}
    slotProps={{
      input: {
        endAdornment: <InputAdornment position="end">{popups}</InputAdornment>,
      },
    }}
  />
);

export default NumberInput;
